import { render, staticRenderFns } from "./StockGroup.vue?vue&type=template&id=fb0d66de&scoped=true&"
import script from "./StockGroup.vue?vue&type=script&lang=js&"
export * from "./StockGroup.vue?vue&type=script&lang=js&"
import style0 from "./StockGroup.vue?vue&type=style&index=0&id=fb0d66de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d66de",
  null
  
)

export default component.exports